import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-card',
  templateUrl: './step-card.component.html',
  styleUrls: ['./step-card.component.scss'],
})
export class StepCardComponent implements OnInit{
  @Input() highlighted: boolean;
  @Input() completed: boolean;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() body: string;

  @Input() imageUri: string;
  
  @Input() buttonLabel: string;
  @Input() buttonUri: string;

  constructor(private _router: Router) {
  }
  ngOnInit(): void {
  }
}
